import { Signatory } from './hidotOvertimeReportUtilities';

import classes from './hidotOvertimeReport.module.css';

type ApprovalRowProps = {
  signatory: Signatory;
};

const ApprovalRow = ({ signatory }: ApprovalRowProps) => {
  return (
    <div className={classes.approvalRow}>
      <div className={classes.approvalCell}>
        <div className={classes.signatoryName}>{signatory?.name}</div>
        <div className={classes.signatoryTitle}>{signatory?.title}</div>
      </div>
      <div className={classes.approvalCell} />
      <div className={classes.approvalCell} />
    </div>
  );
};

export default ApprovalRow;
